<template>
  <!-- TicketDetailLeft -->

  <div class="detail-left">
    <p>
      <span class="strong">联系人</span>
    </p>
    <div>
      <TicketContactUser v-model="ticketEntity"
        @change="onContactUserChange"/>
    </div>

    <p>
      <span class="strong" title="在框中输入名字可搜索并修改">处理人</span>
      <AssignToWorkflowDialog @change="onWorkflowChange"/>
    </p>
    <p>
      <DealUserSearch
        :css="'width:100%'"
        :userId="ticketEntity.dealUserId"
        @change="updateAssignUserId_2"
        ref="assignUser_2"/>
    </p>

    <p title="可以选择并修改">
      <span class="strong">状态</span>
    </p>
    <p>
      <TicketStatusSelect v-model="ticketEntity.orderStatus"
        @change="ticketStatusChange"/>
    </p>

    <p title="可以选择并修改">
      <span class="strong">优先级</span>
    </p>
    <p>
      <el-select
        placeholder="请选择优先级"
        v-model="ticketEntity.orderPriority"
        @change="ticketPriorityChange"
        style="width: 100%;">
        <el-option v-for="item in ticketPriorityList"
          :key="item.value"
          :label="item.name"
          :value="item.value"></el-option>
      </el-select>
    </p>

    <p title="可以选择并修改">
      <span class="strong">类型</span>
    </p>
    <p>
      <TicketTypeCascader
        :css="'width:100%'"
        v-model="ticketEntity.orderType"
        @change="ticketTypeChange"
        ref="ticketType"/>
    </p>

    <p>
      <el-popover width="450" placement="right" trigger="hover">
        <div v-if="ticketCcList && ticketCcList.length>0">
          <div style="font-weight:900;display:inline-block;width:200px;line-height:30px;" 
            v-for="item in ticketCcList" 
            :key="item.id">{{item.name}}({{item.loginName}})</div>
        </div>
        <div v-if="!ticketCcList || ticketCcList.length<1">
          <span style="line-height:30px;" >输入名字或账号,把工单抄送给他</span>
        </div>

        <span v-if="!ticketCcList || ticketCcList.length<1" slot="reference">
          <b class="strong">抄送</b>
          <span style="font-size:10px;">?</span>
        </span>
        <span v-if="ticketCcList && ticketCcList.length>0" slot="reference">
          <b class="strong">抄送</b>
          <span style="font-size:10px;">{{ticketCcList[0].name}}({{ticketCcList[0].loginName}}) 等 {{ticketCcList.length}} 人</span>
        </span>
      </el-popover>
    </p>
    <p>
      <NoticeUserSearch :css="'width:100%'" @change="onTicketCcChange" ref="ticketCc"/>
    </p>

    <p>
      <span class="strong">标签</span>
    </p>
    <p>
      <TicketTag :ticketNo="ticketEntity.orderId" @change="onTicketTagChange" />
    </p>

    <TicketWidgetGroup group="AfterTicketDetailLeft"
      style="width:100%;"/>
  </div>
</template>

<script>
export default {
  name: "TicketDetailLeft",

  props: ['ticket', 'value'], // 用于传入值

  data() {
    return {
      ticketCcList : [],
      ticketPriorityList : [],
      ticketEntity: {},
      orderId : null
    };
  },

  created() {
    // console.log('#113 created TicketDetailLeft', this.ticket, this.value);
  },

  mounted() {
    // console.log('#117 mounted TicketDetailLeft', this.ticket, this.value);

    if ( !!this.value ) {
      this.ticketEntity = this.value;
    }

    console.log('#123 mounted', this.$route);

    // 新建页加载模版数据
    this.loadTicketTemplateDataWhenNew();
  },

  watch : {
      value(_new, _old) {
        // console.log('#118 value, ', _new, _old);

        this.onTicketChange(_new, _old);

        this.ticketEntity = this.value;
      },

      ticket(_new, _old) {
        // console.log('#125 ticket, ', _new, _old);

        this.onTicketChange(_new, _old);

        this.ticketEntity = this.ticket;
      }
  },

  methods: {
    onWorkflowChange( _id ) {
      console.log('#106 onWorkflowChange', _id);

      var _this = this;

      sdk.TicketWorkflowApi().listStartFormPropertyByWorkflowId({
        workflowId : _id
      }).then(res => {
        if ( !!res && res.length > 0 ) {
          _this.$emit('show-start-form', _id);
          return;
        }

        // 无起始表单
        _this.updateWorkflowId(_id);
      });
    },

    updateWorkflowId( _id ) {
      if ( !this.orderId ) {
        console.log("#124 updateWorkflowId, _id=", _id, ", this=", this);
        return;
      }

      var _this = this;
      sdk.TicketApi().updateWorkflowId({
        no :  _this.orderId,
        workflowId : _id
      }).then(() => {
        _message('修改工作流成功' );
        _this.$emit('change', null);
      },err => {
        console.log('#166', err);
        _message(JSON.stringify(err));
      });
    },

    loadTicketCc() {
      if ( !!this.orderId ) { // 工单详情页 加载相关信息
        this.loadTicketCc_byOrderId();
        return;
      }

      // console.log('#180 loadTicketCc', this);
    },

    loadTicketCc_byOrderId() {
      var _this = this;

      sdk.TicketUserApi().listTicketCcByTicketNo({
          ticketNo : _this.orderId
      }).then(res => {
          if ( !res ) {
            console.log('#205 listTicketCcByTicketNo', _this.orderId, res);
            return;
          }

          _this.ticketCcList = res;
          _this.$refs.ticketCc.setList(res);
      });
    },

    loadTicketTemplateDataWhenNew() {
      // 根据模版新建工单页 加载相关信息
      if ( !this.$route.query.templateId ) {
        // console.log('#200 loadTicketTemplateDataWhenNew, not new page with templateId', this.$route);
        return;
      }

      var _this = this;

      sdk.TicketTemplateApi().findMergedById({
          id : _this.$route.query.templateId
      }).then(res => {
          console.log('#216 findMergedById', res);

          // 工单模版指定处理人
          if ( !!res.dealUserId && '' != res.dealUserId && '0' != res.dealUserId ) {
            _this.loadTemplateTicketDealUser(Number(res.dealUserId));
          }

          // 工单模版指定抄送人
          if ( !!res.ticketCc && '' != res.ticketCc && '[]' != res.ticketCc ) {
            _this.loadTemplateTicketCc(JSON.parse(res.ticketCc));
          }
      });
    },

    loadTemplateTicketDealUser( uid ) {
      var _this = this;

      sdk.TicketUserApi().findById({
          id : uid
      }).then(res_2 => {
          if ( !res_2 ) {
            console.log('#232 loadTemplateTicketDealUser', res_2);
            return;
          }

          _this.ticketEntity.dealUserId = uid;

          _this.$refs.assignUser_2.setList([res_2]);
          _this.$refs.assignUser_2.setValue(res_2);
      });
    },

    loadTemplateTicketCc( ccIds ) {
      var _this = this;

      sdk.TicketUserApi().listByIds({
          ids : ccIds
      }).then(res_2 => {
          if ( !res_2 ) {
            console.log('#197 loadTemplateTicketCc', res_2);
            return;
          }

          _this.ticketEntity.ticketCcIds = ccIds;

          _this.ticketCcList = res_2;
          _this.$refs.ticketCc.setList(res_2);
      });
    },

    onTicketChange(_new, _old) {
        var _this = this;
        _this.orderId = _new.orderId;

        // 加载工单抄送人
        _this.loadTicketCc( _new );

        // 新建页加载模版数据
        _this.loadTicketTemplateDataWhenNew();

        // 所有优先级
        sdk.TicketPriorityApi().listCached({
            page : { pageSize : 9999 }
        }).then(res => {
            _this.ticketPriorityList = res;
        });

        // 如果不异步 好像会查出来更新前的数据
        setTimeout(_this.loadTicketDealUser, 500);
    },

    ticketPriorityChange(val) {
      if ( !!this.value ) { // 新建
        this.ticketEntity.orderPriority = val;
        this.$emit('input', this.ticketEntity);
        return;
      }

      var _this = this;
      sdk.TicketApi().updatePriority({
        no : _this.ticket.orderId,
        priority : val
      }).then(()=>{
        _message('修改工单优先级成功');
        _this.$emit('change', null);
      });
    },

    onContactUserChange( e ) {
      if ( !!this.value ) { // 新建页
        this.ticketEntity.contactUserName = e.contactUserName;
        this.ticketEntity.contactUserPhone = e.contactUserPhone;
        this.$emit('input', this.ticketEntity);
        return;
      }

      // 详情页
      var _this = this;
      sdk.TicketApi().updateContactUser({
        no : _this.ticket.orderId,
        contactUserName : e.contactUserName,
        contactUserPhone : e.contactUserPhone
      }).then(() => {
        _message('修改工单联系人成功');
        _this.$emit('change', null);
      });
    },

    onTicketTagChange(vals) {
      if ( !!this.value ) { // 新建
        this.ticketEntity.tags = vals;
        this.$emit('input', this.ticketEntity);
        return;
      }

      this.$emit('change', null);
    },

    onTicketCcChange(vals) {
      if ( !!this.value ) { // 新建
        this.ticketEntity.ticketCcIds = vals.map(e=>e.id);
        this.$emit('input', this.ticketEntity);
        return;
      }

      var _this = this;
      sdk.TicketApi().updateTicketCc({
        no :  _this.ticket.orderId,
        ccUserIds : vals.map(x=>x.id)
      }).then(()=>{
        _message('修改工单抄送人成功');
        _this.$emit('change', null);
      });
    },

    ticketTypeChange(val) {
      if ( !!this.value ) { // 新建
        this.ticketEntity.orderType = val;
        this.$emit('input', this.ticketEntity);
        return;
      }

      // 底下的组件会传入多个 change 事件，暂在此处做个排重
      if ( val == this.ticketType_updating ) {
        console.log('#262 重复 相同 请求', this);
        return;
      }

      this.ticketType_updating = val;

      var _this = this;
      sdk.TicketApi().updateType({
        no : _this.ticket.orderId,
        type : val
      }).then(() => {
        _message('修改工单类型成功');
        _this.$emit('change', null);

        // 清理
        _this.ticketType_updating = null;
      });
    },

    updateAssignUserId_2(val) {
      if ( !!this.value ) { // 新建
        this.ticketEntity.dealUserId = val;
        this.$emit('input', this.ticketEntity);
        return;
      }

      // 更新
      var _this = this;
      sdk.TicketApi().updateDealUser({
        no : _this.ticketEntity.orderId,
        dealUserId : val
      }).then(() => {
        _message('修改工单处理人成功');
        _this.$emit('dealUserChange', null); // 单独的事件, 不重新加载左栏
      });
    },

    ticketStatusChange(val) {
      if ( !!this.value ) { // 新建
        this.ticketEntity.orderStatus = val;
        this.$emit('input', this.ticketEntity);
        return;
      }

      var _this = this;
      sdk.TicketApi().updateStatus({
        no : _this.ticket.orderId,
        status : val
      }).then(()=>{
        _message('修改工单状态成功');
        _this.$emit('change', null);
      });
    },

    loadTicketDealUser() {
      if ( !this.orderId ) {
        return;
      }

      var _this = this;

      sdk.TicketUserApi().findDealUserByTicketNo({
        ticketNo : _this.orderId
      }).then(res => {
        if ( !res ) {
          return;
        }

        _this.$refs.assignUser_2.setList([res]);
        _this.$refs.assignUser_2.setValue(res);
      });
    }
  }
};
</script>

<style>
.contact_1 {
  white-space:nowrap;
  line-height: 36px;
  height: 36px;
  border: 1px solid #dcdfe6;
  padding: 0px 15px;
  color: #000000;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketDetailLeft.vue